<nz-modal
  [nzMaskClosable]="false"
  [nzNoAnimation]="true"
  [nzVisible]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  nzWidth="100%"
>
  <ng-template #modalTitle>
    <div class="order-modal-title">
      <span class="order-modal-title-main">
        {{ title }}
        @if (!isNew && headerStatus) {
          <span class="status-pill" [attr.data-status]="headerStatus">{{ headerStatus | statusFormat }}</span>
        }
      </span>
      @if (!isNew && object?.id) {
        <button
          nz-button
          nzType="default"
          nzSize="small"
          type="button"
          nz-tooltip
          nzTooltipTitle="Änderungsprotokoll öffnen"
          (click)="openChangeLog($event)"
        >
          <i nz-icon nzType="history"></i>
          Änderungsprotokoll
        </button>
      }
    </div>
  </ng-template>

  <ng-template #modalContent>
    <app-add-edit-order-form
      #form
      [orderType]="orderType"
      [editObject]="object"
      (formFinished)="onFormFinished($event)"
      (orderSynced)="onOrderSynced($event)"
    ></app-add-edit-order-form>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Abbrechen</button>
    <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Speichern</button>
  </ng-template>
</nz-modal>

<app-order-change-log-modal #orderChangeLogModal></app-order-change-log-modal>
